'use client'

/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */
import React, { useState, useEffect } from 'react'
import { fetchPageNumbers } from '@helpers/commonHelpers'
import { DEFAULT_PAGINATION_VALUE } from '@components/Ackodrive/common/constants'
import { PaginatorWrapper, TotalPages, PageControls, PageChangeButtons, PageNumberList, PageNumber } from './styles'

const Paginator = ({ isMobile, currentPage, rangeLimit, handlePaginationChange, pageUrl }) => {
  currentPage = currentPage || 0
  const [page, setPageNumber] = useState(DEFAULT_PAGINATION_VALUE)

  useEffect(() => {
    return setPageNumber(currentPage || DEFAULT_PAGINATION_VALUE)
  }, [currentPage])

  const moveToPage = pageNumber => {
    handlePaginationChange(pageNumber)
    return setPageNumber(pageNumber)
  }

  const renderPageIndicators = (num, index) => (
    <PageNumber
      key={index}
      onClick={e => {
        e.preventDefault()
        moveToPage(num)
      }}
      className={page === num ? 'selected' : ''}
      href={num === 1 ? `${pageUrl}` : `${pageUrl}page/${num}/`}>
      {num}
    </PageNumber>
  )

  return (
    <PaginatorWrapper id="paginator">
      <TotalPages>
        Page {currentPage}&nbsp;of&nbsp;{rangeLimit}
      </TotalPages>
      <PageControls isMobile={isMobile}>
        <PageChangeButtons
          className={currentPage == DEFAULT_PAGINATION_VALUE ? 'selected' : ''}
          onClick={() => moveToPage(page - 1)}>
          &#x2039;
        </PageChangeButtons>
        <PageNumberList>{fetchPageNumbers(rangeLimit, currentPage).map(renderPageIndicators)}</PageNumberList>
        <PageChangeButtons className={currentPage == rangeLimit ? 'selected' : ''} onClick={() => moveToPage(page + 1)}>
          &#x203A;
        </PageChangeButtons>
      </PageControls>
    </PaginatorWrapper>
  )
}

export default Paginator
